//
import React from 'react';
import { StyleSheet } from 'react-native';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING } from '../../constants';
import { useAlert } from '../../redux/alert/alertHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import FormCadastro from './FormCadastro';

const CadastroPage: React.FC = () => {
  const [sessao, login, logout] = useSessao();
  const [mostrarAlert] = useAlert();

  return (
    <PageContainer header={<Header goBack />}>
      <FormCadastro
        onCadastro={(novoCli, senha) => {
          if (novoCli.email !== '') {
            login(novoCli.email, senha);
          } else {
            login(novoCli.celular, senha);
          }
        }}
      />
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff'
  },
  content: {
    paddingTop: TOP_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  form: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default CadastroPage;
